import { ErrorType } from '../../components'
import { useErrorTrigger } from '../useErrorTrigger'
import { MaybeFetchState, StatusType } from './types'

export const useIsLoading = <T,>(
  fetchState: MaybeFetchState<T>,
  fetchErrorType: ErrorType
) => {
  // TODO: fix this when ts 4.4 in use
  const statusType = fetchState?.status

  useErrorTrigger(
    fetchState?.status === StatusType.ERROR
      ? { error: fetchState.error, errorType: fetchErrorType }
      : undefined
  )

  const isLoading = [StatusType.FETCHING, StatusType.INIT, undefined].includes(
    statusType
  )

  return { isLoading }
}
